export const getWaimeaPlainsData = () => ({
  name: "Waimea Plains",
  region: "Nelson",
  country: "Nouvelle-Zélande",
  description: "Waimea Plains est une sous-région viticole de Nelson, réputée pour ses vins rouges et blancs équilibrés. Les sols alluviaux et le climat tempéré favorisent la production de vins frais et expressifs.",
  type: "subregion",
  area: "400 ha",
  production: "0.03 million hectolitres",
  climate: "Climat tempéré avec influences maritimes, étés chauds et hivers doux",
  soil: "Sols alluviaux, bonne rétention d'eau, diversité géologique",
  characteristics: {
    climate: "Climat tempéré avec influences maritimes, étés chauds et hivers doux",
    soil: "Sols alluviaux, bonne rétention d'eau, diversité géologique",
    viticulture: "Viticulture durable, rendements contrôlés, diversité de cépages"
  },
  wineStyles: {
    white: "Chardonnay frais, Sauvignon Blanc aromatique, Riesling minéral",
    red: "Pinot Noir fruité, tanins souples",
    rosé: "Rosés légers et fruités"
  },
  history: "Waimea Plains s'est développée dans les années 2000 comme une zone viticole innovante à Nelson, avec une attention particulière à la fraîcheur et à l'expression du fruit.",
  foodPairing: "Poissons, fruits de mer, fromages frais, plats d'été",
  grapeVarieties: [
    { name: "Pinot Noir", percentage: "35%", description: "Vins rouges fruités, tanins souples" },
    { name: "Chardonnay", percentage: "30%", description: "Vins frais, équilibrés" },
    { name: "Sauvignon Blanc", percentage: "20%", description: "Vins aromatiques, acidité vive" },
    { name: "Riesling", percentage: "10%", description: "Vins blancs minéraux, acidité marquée" },
    { name: "Autres", percentage: "5%", description: "Pinot Gris, expérimentaux" }
  ],
  statistics: {
    totalArea: "400 ha",
    production: "0.03 million hectolitres",
    wineries: "8+ domaines",
    exportPercentage: "25%"
  },
  viticulture: "La viticulture à Waimea Plains privilégie la fraîcheur et la diversité des cépages. Les rendements sont modérés pour préserver l'aromatique.",
  winemaking: "La vinification se fait en cuves inox pour les blancs et en fûts pour les rouges. Les styles varient selon les producteurs.",
  terroir: "Waimea Plains est caractérisée par ses sols alluviaux et son climat tempéré, permettant une grande diversité de styles et de cépages.",
  mapAreas: [
    { region: "Waimea Plains", x: 173.2, y: -41.4, color: "#6d2c7a", size: 3 }
  ]
}); 